import Lazy from './lazy';
import LazyComponent from './lazy-component';

export default {
  /*
  * install function
  * @param  {Vue} Vue
  * @param  {object} options  lazyload options
  */
  install(Vue, options = {}) {
    const LazyClass = Lazy(Vue);
    const lazy = new LazyClass(options);
    Vue.component('lazy-component', LazyComponent(lazy));
  },
};
